<template>
    <v-select
    v-model="selDatas"
    :items="selItems"
    persistent-hint
    outlined
    dense
    :menu-props="{ maxHeight: '200px', bottom: '100px' }"
    
>
</v-select>

  </template>
  <script>
export default {
name: 'SelectBox',
props: {
    datas: {
        type: String,
        required: true
    },
    items: {
        type: Array,
        required: true
    },
},
    data () {
        return {

        }
    },
    computed: {
        selDatas:{
            get(){
                return this.datas;
            },
            set(newVal){
                return this.$emit('item-selected', newVal);
            }
        },
        selItems(){
            return this.items;
        },
        labelText(){
            return this.label;
        }
    },
    methods: {
       
    }
}
</script>

<style scoped>
.v-select__menu {
  top: unset !important; /* 기본적으로 적용되는 top 속성 제거 */
  bottom: 0; /* 메뉴를 input 아래로 내리기 위해 bottom에 0 설정 */
}
.group_chip{
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 6px;
}
.group_chip_more{
    font-size: 12px;
    color: #aaa;
}
</style>